import { AxiosError } from 'axios';
import { POST_ONLINE_TUTORIALS_LISTING } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { ApiPathParam } from '../../models/SearchParamSchema';
import { PaginationSchema, SortingSchema } from '../../models/PaginationSchema';
import {GenericErrorResponse, KeyValueResponse} from '../typings';

export interface OnlineTutorialsListingContent {
  description: string;
  examLevel: string;
  fileKey: string;
  fileName: string;
  resourceType: string;
  title: string;
  updatedAt: string;
  uuid: string;
}

export interface OnlineTutorialsListingResponse {
  content: OnlineTutorialsListingContent[];
  pageable: PaginationSchema;
  totalElements: number;
  last: boolean;
  totalPages: number;
  size: number;
  number: number;
  sort: SortingSchema;
  first: boolean;
  numberOfElements: number;
  empty: boolean;
}

export interface NonNationalExamApplicationSearchRequest {
  examLevels: KeyValueResponse[];
  resourceTypes: KeyValueResponse[];
  apiParams: ApiPathParam;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess: (data: OnlineTutorialsListingResponse) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostOnlineTutorials = ({ onSuccess, onError }: Input) => {
  const postOnlineTutorials = async (requestBody: NonNationalExamApplicationSearchRequest) => {
    const updatedRequestBody = JSON.parse(JSON.stringify(requestBody));
    delete updatedRequestBody.apiParams;

    const res = await axiosClient.post<OnlineTutorialsListingResponse>(
      POST_ONLINE_TUTORIALS_LISTING(requestBody.apiParams),
      updatedRequestBody
    );

    return res.data;
  };

  return useCustomMutation(
    postOnlineTutorials,
    {
      onSuccess,
      onError,
    },
    true,
    false
  );
};
